import { render, staticRenderFns } from "./modal-Avaliacao-Risco-Apa.vue?vue&type=template&id=008d6d77&scoped=true"
import script from "./modal-Avaliacao-Risco-Apa.vue?vue&type=script&lang=ts"
export * from "./modal-Avaliacao-Risco-Apa.vue?vue&type=script&lang=ts"
import style0 from "./modal-Avaliacao-Risco-Apa.vue?vue&type=style&index=0&id=008d6d77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008d6d77",
  null
  
)

export default component.exports